import { render, staticRenderFns } from "./UpdatePasswordForm.vue?vue&type=template&id=497ce239&scoped=true"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=ts"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ce239",
  null
  
)

export default component.exports